import { format, isToday } from 'date-fns';
import CartSimple from './CartSimple';
import { rupiah } from 'lib/currency';
import { formatTimeDisplay } from 'lib/timeHelpers';

const CartSummary = ({ scheduleData, classData, item, quantity, setQuantity }) => {
  const date = new Date();
  const price = Number(item?.price ?? 0);
  const subTotal = price * quantity;
  const tax = Math.round(subTotal * 0.1);
  const grandTotal = subTotal + tax;

  const formatPickDate = (paramsDate) => {
    const labelToday = isToday(paramsDate) ? 'Today, ' : '';
    return `${labelToday}${format(paramsDate, 'EEEE d MMMM')}`;
  };

  return (
    <div className="rounded-2xl p-6 bg-white text-kin-text">
      <h5 className="font-semibold text-base">Your Passes</h5>
      <div className="flex flex-col divide-y-[0.5px] divide-kin-text">
        {scheduleData && (
          <div className="flex flex-col gap-1 items-start">
            <div className="flex flex-row gap-3 items-start py-4">
              <div className="w-4 h-4 relative">
                <img
                  alt="icon-calender"
                  src="/kin/assest/image/icon-calender.svg"
                  className="absolute inset-0 h-full w-full object-cover"
                />
              </div>
              <div className="flex flex-col gap-[2px]">
                <span className="leading-[normal] font-light text-sm uppercase">
                  {scheduleData?.start_date ? formatPickDate(scheduleData.start_date) : '-'}{' '}
                </span>
                <span className="leading-[normal] text-base font-bold">
                  {classData?.data?.class?.name || '-'}
                </span>
                <span className="leading-[normal] text-sm font-light">
                  {classData?.data?.class?.theme || '-'}
                </span>
                <span className="leading-[normal] text-sm font-light">
                  {`${
                    scheduleData?.start_time ? formatTimeDisplay(scheduleData.start_time) : '-'
                  } - ${scheduleData?.end_time ? formatTimeDisplay(scheduleData.end_time) : '-'}`}
                </span>
              </div>
            </div>
          </div>
        )}

        <div>
          {!item ? (
            <p className="text-sm text-gray-500 mt-3">No passes in cart</p>
          ) : (
            <CartSimple item={item} quantity={quantity} setQuantity={setQuantity} />
          )}
        </div>

        <div>
          <dl className="space-y-2 py-4 text-sm text-kin-text">
            <div className="flex justify-between">
              <dt className="font-light">SUBTOTAL</dt>
              <dd className="font-semibold">{rupiah(subTotal)}</dd>
            </div>
            <div className="flex justify-between">
              <dt className="font-light">TAX 10%</dt>
              <dd className="font-semibold">{rupiah(tax)}</dd>
            </div>
          </dl>
        </div>

        <div>
          <dl className="space-y-2 py-4 text-sm text-kin-text">
            <div className="flex justify-between">
              <dt className="font-light">GRAND TOTAL</dt>
              <dd className="font-semibold">{rupiah(grandTotal)}</dd>
            </div>
          </dl>
        </div>
      </div>
    </div>
  );
};

export default CartSummary;
